var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"send-invite"},[_c('add-to-call-container',{attrs:{"webrtc-alias":_vm.webrtcAlias},on:{"send-emails":_vm.sendEmails,"dial-endpoint":_vm.dialEndpoint,"close-invite":_vm.closeInvite}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }